module.exports = __webpack_public_path__ + "static/media/Pharmacy_ThankYou_elements.9151e2f0.png";